type PickFileOptions<TMultiple extends boolean> = {
  acceptedFileTypes?: string[];
  multiple?: TMultiple;
};

export const pickFile = <TMultiple extends boolean = false>({
  acceptedFileTypes = ['*'],
  multiple = false as TMultiple
}: PickFileOptions<TMultiple>): Promise<TMultiple extends true ? File[] : File | null> => {
  return new Promise((resolve, reject) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = acceptedFileTypes.join(', ');
    fileInput.multiple = multiple;

    fileInput.onchange = () => {
      const files = fileInput.files;

      if (!files) {
        resolve(multiple ? [] : (null as any));
      } else {
        resolve(multiple ? Array.from(files) : (files.item(0) as any));
      }
    };

    fileInput.onerror = reject;

    fileInput.click();
  });
};
